import apiClientV2 from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_BFF_URL

export const duplicate = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/fleet-task-instant/duplicate',
    data,
  })

  return response?.data
}